/**
 * Базовая модель фильтра
 */
export class BaseFilterModel {
  search = ''; // поле простого поиска
}
